fx.service(class FaceService extends fx.Service
{
    constructor(model)
    {
        super();

        this._model = model;

        this._aiserver = this.model.servers.aiServers.getItemAt(0);

        if (this._aiserver)
            this.endpoint = this._aiserver.url + "/v2/face-detection";

        this._queue = [];

        this._initialized = false;
        this._failedCount = 0;
        this._MAX_FAILED_COUNT = 10;
        this._MAX_TIMEOUT = 1000;
    }

    get model()
    {
        return this._model
    }

    
    init()
    {
        if (!this._initialized && this._aiserver)
        {
            this._initialized = true;
            this.on("photo-upload", this._onPhotoExtracted, fx.service("MediasUploader"));
        }
    }

    stop()
    {
        if (this._initialized)
        {
            this._initialized = false;
            this.off("photo-upload", this._onPhotoExtracted, fx.service("MediasUploader"));
        }
    }


    _onPhotoExtracted(event)
    {
        let photo = event.detail;
        photo.analysing = true;

        this._queue.push(photo);

        this._process();
    }


     _process()
    {
        if (this._queue.length > 0 && !this._currentPhoto)
        {
             this._currentPhoto = this._queue.shift();

            this._analysePhoto();
        }
    }


    _analysePhoto()
    {
        try 
        {
            var formData = new FormData();
            
            if(this._currentPhoto.base64)
            {
                formData.append('file', /base64,(.+)/.exec(this._currentPhoto.base64)[1]);
                formData.append('base64', true);
            }
            else
            {
                formData.append('url', this._currentPhoto.thumb);
                formData.append('base64', false);
            }
            
            formData.append('id_photo', this._currentPhoto.temporaryId);
            formData.append('date', this._currentPhoto.date_takenSQL || this._currentPhoto.date_taken || this._currentPhoto.date);
            formData.append('bookid', this.model.creation.id);
            formData.append('width', this._currentPhoto.width);
            formData.append('height', this._currentPhoto.height);
            formData.append('latitude', this._currentPhoto.latitude);
            formData.append('longitude', this._currentPhoto.longitude);
            
            this.post(formData, this._photoAnalysed, {processData: false,  contentType: false, maxTries : 1, timeout : this._MAX_TIMEOUT  });   
            
            this.trigger("photo-analyse-started", this);
        }
        catch(e)
        {
            this._photoAnalysed({error : true});
        }
    }

    _photoAnalysed(data)
    {
        if (data.error)
        {
            //this.trigger("photo-analyse-error", this);
            this._failedCount++;
            if (this._failedCount >= this._MAX_FAILED_COUNT)
                this.stop();
        }
        else
        {
            this._currentPhoto.setFaces(data);
            //this.trigger("photo-analyse-finished", this);
        }

        this._currentPhoto.analysing = false;
        this._currentPhoto = null;

        this._process();
    }
});